<template lang="pug">
    // Time Picker field
    div
        v-menu(
            ref="menu"
            transition="scale-transition"
            max-width="290px"
            min-width="290px"
            lazy
            offset-y
            full-width
            v-model="menuTime"
            :close-on-content-click="false"
            :return-value.sync="time"
            :nudge-right="40"
        )
            template(v-slot:activator="{ on }")
                v-text-field.marginTop(
                    :append-icon="iconName"
                    name="time"
                    v-on="on"
                    readonly
                    outline
                    hide-details
                    :value="time | formattedTime"
                    :label="label"
                )

            v-time-picker(
                color="primary"
                full-width
                v-if="menuTime"
                v-model="time"
                @click:minute="setTime"
            )
</template>

<script>
    import VueTypes from 'vue-types';
    import formattedTime from '~filters/FormattedTime';

    export default {
        props: {
            label: VueTypes.string.def('Time'),
            timePickerCallback: VueTypes.func.def(() => {}),
            predefinedTime: VueTypes.string.def(''),
            icon: VueTypes.string.def('')
        },
        filters: {
            formattedTime
        },
        data() {
            return {
                menuTime: false,
                time: this.predefinedTime
            };
        },
        computed: {
            iconName() {
                return this.icon ? this.icon : 'expand_more';
            }
        },
        watch: {
            predefinedTime(val, oldVal) {
                if (val === oldVal) return;
                this.time = val;
            }
        },
        methods: {
            setTime() {
                this.$refs.menu.save(this.time);
                this.timePickerCallback(this.time);
            }
        }
    };
</script>
